import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Dialog, TextField, RaisedButton, FontIcon, FlatButton, Table, TableHeader, TableBody, TableRowColumn, TableRow, TableHeaderColumn } from 'material-ui';
import R from 'ramda';
import { isValidEmail } from '../../../utils/validations';
import { updateSettingsProps, addSecondaryEmail, resendSecondaryEmailConfirmationLink, confirmedDisassociateSecondaryEmail } from '../../../stores/settings/settings-actions';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

class AssocEmails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editingEmailObj: {},
      showAddEmail: false,
      tempSecondaryEmail: '',
    };
  }

  render() {
    const { settings, resendConfirmLink, addSecEmail, removeSecEmail, updateProp } = this.props;
    const { editingEmailObj, showAddEmail, tempSecondaryEmail } = this.state;
    const secondaryEmails = settings.secondaryEmails;
    const secondaryEmailsInfo = R.propOr({}, 'secondaryEmailsInfo', settings);
    const resetState = () => this.setState({ editingEmailObj: {}, showAddEmail: false, tempSecondaryEmail: '' });
    const fullWidth = R.isEmpty(editingEmailObj) || !R.isEmpty(editingEmailObj) && editingEmailObj.is_confirmed;

    return (
      <div>
        <div style={{ paddingBottom: '12px', borderBottom: '1px solid #e6e9ec', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ fontSize: '24px', fontWeight: 400 }}>Associated Emails</div>
          <div style={{ display: 'flex', alignItems: 'center' }}><RaisedButton label="Associated Email" icon={<FontIcon className="tc-icon-add" style={{ fontSize: '16px', marginTop: '-3px' }}/>} onTouchTap={() => this.setState({ showAddEmail: true })} secondary /></div>
        </div>
        <div>
          {
            R.isEmpty(secondaryEmails) ?
              <div>You do not have any associated emails.</div> :
              <div>
                <Table selectable={false} bodyStyle={{ maxHeight: '300px', overflowY: 'scroll' }}>
                  <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow>
                      <TableHeaderColumn style={{ width: fullWidth ? '45%' : '40%', textAlign: 'center' }}>Email</TableHeaderColumn>
                      <TableHeaderColumn style={{ width: fullWidth ? '40%' : '20%', textAlign: 'center' }}>Status</TableHeaderColumn>
                      <TableHeaderColumn style={{ padding: '0' }} />
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox ={false}>
                    {
                      secondaryEmails.map((emailObj, i) => (
                        <TableRow key={i}>
                          <TableRowColumn style={{ width: fullWidth ? '45%' : '40%' }}>{emailObj.email}</TableRowColumn>
                          <TableRowColumn style={{ width: fullWidth ? '40%' : '20%', textAlign: 'center' }}>{emailObj.is_confirmed ? 'Confirmed' : 'Pending'}</TableRowColumn>
                          {
                            R.equals(R.propOr('', '_id', editingEmailObj), emailObj._id) ?
                              <TableRowColumn style={{ padding: '0', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                {!emailObj.is_confirmed &&
                                  <FlatButton
                                    onTouchTap={() => {
                                      resendConfirmLink(emailObj.email);
                                      resetState();
                                    }}
                                    secondary
                                    label="Resend Confirmation"
                                  />}
                                <FlatButton
                                  onTouchTap={() => {
                                    const confirm = window.confirm(`Are you sure that you want to remove ${emailObj.email} ?`);
                                    if (confirm) {
                                      removeSecEmail(emailObj._id);
                                      resetState();
                                    }
                                  }}
                                  label="Remove"
                                  primary
                                />
                                <FontIcon
                                  onTouchTap={() => resetState()}
                                  className="tc-icon-close"
                                  style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.54)', cursor: 'pointer', margin: '4px 10px 0 0' }}
                                />
                              </TableRowColumn> :
                              <TableRowColumn style={{ padding: '0', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <FontIcon
                                  className="tc-icon-mode_edit"
                                  style={{ fontSize: '12px', color: 'rgb(0, 165, 187)', cursor: 'pointer', margin: '0 10px' }}
                                  onTouchTap={() => this.setState({ editingEmailObj: emailObj })}
                                />
                              </TableRowColumn>
                          }
                        </TableRow>
                      ))
                    }
                  </TableBody>
                </Table>
              </div>
          }
        </div>
        <Dialog
          title="Add New Associated Email"
          actions={[
            <FlatButton
              onTouchTap={() => {
                resetState();
                updateProp({ secondaryEmailsInfo: {} });
              }}
              label="Cancel"
              primary
              style={{ marginLeft: '10px' }}
            />,
            <FlatButton
              onTouchTap={() => {
                addSecEmail(tempSecondaryEmail)
                .then(res => {
                  if (!R.propOr(false, 'error', res.payload)) {
                    resetState();
                  }
                });
              }}
              label="Add"
              secondary
              disabled={R.isEmpty(tempSecondaryEmail) || !isValidEmail(tempSecondaryEmail)}
            />,
          ]}
          modal
          open={showAddEmail}
          onRequestClose={() => resetState()}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {!isNilOrEmpty(R.propOr('', 'error', secondaryEmailsInfo)) && <div style={{ color: 'red', display: 'flex', width: '95%', margin: '0 0 10px 20px' }}>{secondaryEmailsInfo.message}</div>}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <TextField
                hintText="Email"
                value={tempSecondaryEmail}
                onChange={({ target: { value } }) => this.setState({ tempSecondaryEmail: value })}
                style={{ width: '95%' }}
              />
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

AssocEmails.propTypes = {
  resendConfirmLink: PropTypes.func,
  settings: PropTypes.object,
  addSecEmail: PropTypes.func,
  removeSecEmail: PropTypes.func,
  updateProp: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  resendConfirmLink: email => dispatch(resendSecondaryEmailConfirmationLink(email)),
  removeSecEmail: id => dispatch(confirmedDisassociateSecondaryEmail(id)),
  addSecEmail: email => dispatch(addSecondaryEmail(email)),
  updateProp: (...args) => dispatch(updateSettingsProps(...args)),
});

const mapStateToProps = ({ settings }) => ({
  settings: settings.toJS(),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssocEmails);



// WEBPACK FOOTER //
// ./src/app/components/settings/companySettings/assocEmails.jsx